var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverButtoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2210_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.112109 1.04453C0.0382812 0.935156 0 0.803906 0 0.672656C0 0.300781 0.300781 0 0.672656 0H3.66133C3.96758 0 4.25469 0.161328 4.41055 0.423828L6.28359 3.54375C4.96563 3.71055 3.78711 4.32578 2.90938 5.23633L0.112109 1.04453ZM13.8852 1.04453L11.0906 5.23633C10.2129 4.32578 9.03438 3.71055 7.71641 3.54375L9.58945 0.423828C9.74805 0.161328 10.0324 0 10.3387 0H13.3273C13.6992 0 14 0.300781 14 0.672656C14 0.803906 13.9617 0.935156 13.8879 1.04453H13.8852ZM2.1875 9.1875C2.1875 7.91115 2.69453 6.68707 3.59705 5.78455C4.49957 4.88203 5.72365 4.375 7 4.375C8.27635 4.375 9.50043 4.88203 10.403 5.78455C11.3055 6.68707 11.8125 7.91115 11.8125 9.1875C11.8125 10.4639 11.3055 11.6879 10.403 12.5905C9.50043 13.493 8.27635 14 7 14C5.72365 14 4.49957 13.493 3.59705 12.5905C2.69453 11.6879 2.1875 10.4639 2.1875 9.1875ZM7.22969 6.59258C7.13672 6.40117 6.86602 6.40117 6.77031 6.59258L6.15781 7.83398C6.11953 7.91055 6.04844 7.9625 5.96641 7.97344L4.59375 8.17305C4.3832 8.20312 4.30117 8.46016 4.45156 8.61055L5.44414 9.57852C5.5043 9.63867 5.53164 9.7207 5.51797 9.80547L5.28281 11.1699C5.24727 11.3777 5.46602 11.5391 5.65469 11.4406L6.87969 10.7953C6.95352 10.757 7.04375 10.757 7.11758 10.7953L8.34258 11.4406C8.53125 11.5391 8.75 11.3805 8.71445 11.1699L8.4793 9.80547C8.46563 9.72344 8.49297 9.63867 8.55312 9.57852L9.5457 8.61055C9.69883 8.46289 9.61406 8.20586 9.40352 8.17305L8.03359 7.97344C7.95156 7.9625 7.87773 7.90781 7.84219 7.83398L7.22969 6.59258Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2210_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverButtoImage);
export default __webpack_public_path__ + "static/media/silver-butto-image.1c30cd8d11d11cdd640a6783e815798d.svg";
export { ForwardRef as ReactComponent };